import React, {useEffect, useState} from "react";
import moment from "moment";
import {isArray, isNull} from "lodash";
import getData from "./helpers/getData";
import createStockChart from "./helpers/createStockChart";
import {fetchLastDay, isOneDaySelected} from "./helpers/dateHelpers";

const StockGraph = ({symbol, symbolIndex, idNumber}) => {
  const idSuffix = `-${symbol}-${symbolIndex}-${idNumber}`;
  const elementId = "stock-graph" + idSuffix;
  const dateStartId = "begin" + idSuffix;
  const dateEndId = "end" + idSuffix;
  const heightGraph = 450;
  const CUSTOM_DEFAULT_SET = {
    customAsValue: 0, // 0 = custom value
    periodValue: 1,
    periodUnit: "month"
  }
  const [readyToRender, setReadyToRender] = useState(false);
  const [error, setError] = useState(null);
  const [period, setPeriod] = useState(CUSTOM_DEFAULT_SET.customAsValue);
  const [date, setDate] = useState({
    begin: moment()
      .subtract(CUSTOM_DEFAULT_SET.periodValue, CUSTOM_DEFAULT_SET.periodUnit)
      .format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD")
  });
  const [compareWithIndex, setCompareWithIndex] = useState(false);

  const handleChangeDate = value => {
    setReadyToRender(false);
    setPeriod(CUSTOM_DEFAULT_SET.customAsValue);
    if (value.target.id === dateStartId) {
      setDate({
        ...date,
        begin: value.target.value
      });
    } else if (value.target.id === dateEndId) {
      setDate({
        ...date,
        end: value.target.value
      });
    }
  };

  useEffect(() => {
    getData(date, symbol, symbolIndex).then(data => {
      setReadyToRender(true);
      if (isArray(data.amrest) && isArray(data.amrest)) {
        if (isOneDaySelected(date)) {
          createStockChart(data, elementId, compareWithIndex, symbolIndex, isOneDaySelected(date));
        } else {
          createStockChart(data, elementId, compareWithIndex, symbolIndex, isOneDaySelected(date));
        }
        setError(null);
      } else {
        setError(data.amrest);
      }
    });
  }, [date, compareWithIndex]);

  const periods = [
    {
      id: 0,
      value: 1,
      name: Drupal.t("1 day")
    },
    {
      id: 1,
      value: 5,
      name: Drupal.t("5 days")
    },
    {
      id: 2,
      value: 90,
      name: Drupal.t("3 months")
    },
    {
      id: 3,
      value: 365,
      name: Drupal.t("1 year")
    },
    {
      id: 4,
      value: 1095,
      name: Drupal.t("3 years")
    },
    {
      id: 5,
      value: 0,
      name: Drupal.t("custom")
    }
  ];

  const onChangePeriod = value => {
    setReadyToRender(false);
    setPeriod(value);
    if (value !== 1) {
      if (value === CUSTOM_DEFAULT_SET.customAsValue) {
        value = moment().diff(moment().subtract(CUSTOM_DEFAULT_SET.periodValue, CUSTOM_DEFAULT_SET.periodUnit), 'days');
      }
      setDate({
        begin: moment()
          .subtract(value, "days")
          .format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });
      // for "1 day period" we get last day from api
    } else {
      fetchLastDay(symbol).then(day => {
        setDate({
          begin: moment(day).format("YYYY-MM-DD"),
          end: moment(day).format("YYYY-MM-DD")
        });

      });
    }
  };

  const buttonPeriods = periods.map(({name, value}, i) => (
    <button
      type="button"
      className={"square-select text-nowrap" + (period === value ? " selected " : "")}
      onClick={() => onChangePeriod(value)}
      key={'buttonPeriods' + i}
    >
      {name}
    </button>
  ));

  if (readyToRender) {
    return (
      <div className="">
        <div className="chart-controls ">
          <div className="chart-buttons">
            {buttonPeriods}
          </div>
        <form className="form-inline mb-3">
          <div className="form-group form--select-wrapper mr-4">
            <label htmlFor={dateStartId}>
              {Drupal.t("from")}:
            </label>
            <input
              className="form-control"
              type="date"
              max={moment(date.end)
                .subtract(3, "day")
                .format("YYYY-MM-DD")}
              id={dateStartId}
              name="trip-start"
              value={date.begin}
              onChange={handleChangeDate}
              disabled={period !== CUSTOM_DEFAULT_SET.customAsValue}
            />
          </div>

          <div className="form-group form--select-wrapper">
            <label htmlFor={dateEndId}>
              {Drupal.t("to")}:
            </label>
            <input
              className="form-control"
              type="date"
              id={dateEndId}
              min={moment(date.begin)
                .add(1, "day")
                .format("YYYY-MM-DD")}
              max={moment().format("YYYY-MM-DD")}
              name="trip-start"
              value={date.end}
              onChange={handleChangeDate}
              disabled={period !== 0}
            />
          </div>
        </form>


        </div>
        {!isNull(error) ? (
          <div className="alert alert-warning mb-3">{error}</div>
        ) : null}

        <div
          id={elementId}
          className="mb-3"
          style={{height: `${heightGraph}px`}}
        />

        <div className="row mb-3">
          <div className="col pl-0">
            <div className="form-check">
              <span className="pr-4 d-inline-block mr-2"><strong>{Drupal.t("Compare")}:</strong></span>
              <input
                type="checkbox"
                defaultChecked={compareWithIndex}
                className="form-check-input"
                id="exampleCheck1"
                onChange={action => setCompareWithIndex(action.target.checked)}
              />
              <label className="form-check-label" htmlFor="exampleCheck1">
                {Drupal.t(symbolIndex)}
              </label>
            </div>
          </div>
        </div>

      </div>
    );
  }

  return (
    <div
      className="d-flex justify-content-center pb-4 pt-4"
      style={{height: `${heightGraph}px`}}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default StockGraph;
